import { t } from 'i18n';
import { BottomSheet, Input, styled } from '@teko/ds-mobile';
import React, { useState } from 'react';
import { BuildPcModalComponent } from './BuildPcModalComponent';
import { SearchOutlined } from '@teko/ds-icon';

interface BuildPcModalProps {
  collectionSlug: string;
  categoryName: string;
  visible: boolean;
  onClose: () => void;
}

const BOTTOM_SHEET_HEADER_HEIGHT = '57px';

export const BuildPCModalMobile: React.FC<BuildPcModalProps> = (props) => {
  const { collectionSlug, categoryName, visible, onClose } = props;
  const [keyword, setKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const onClickSearch = (keyword: string) => {
    setKeyword(keyword);
    setCurrentPage(1);
  };

  return (
    <StyledBottomSheet
      zIndex={1060}
      show={visible}
      closeBottomSheet={onClose}
      forceRender
      closeIconPosition="right"
      contentHeight={`calc(100% - ${BOTTOM_SHEET_HEADER_HEIGHT})`}
      showBottomSheetHeader
      filterNode={
        <Input
          placeholder={t('Tìm kiếm')}
          width="80%"
          marginLeft="s20"
          onKeyUp={(e) => {
            const keyword = (e.target as HTMLInputElement).value;
            if (e.keyCode === 13) {
              onClickSearch(keyword);
            }
          }}
          prefix={<SearchOutlined size={20} />}
        />
      }
    >
      <BuildPcModalComponent
        collectionSlug={collectionSlug}
        categoryName={categoryName}
        keyword={keyword}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
        onClose={onClose}
      />
    </StyledBottomSheet>
  );
};

const StyledBottomSheet = styled(BottomSheet)`
  height: 100%;
  width: 100%;
  overflow-y: visible;
  -webkit-overflow-scrolling: auto;
  .bottom-sheet-header {
    padding: 8px;
    height: ${BOTTOM_SHEET_HEADER_HEIGHT};
  }
`;
